module.exports = __webpack_public_path__ + "img/pc.c7f6ed1b.gif";